module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4e3f70751c8962ab6a7b5d5992348c93.png";